<template>
  <div id="newSurvey">
    <topBar :title="$t('user.title')" />
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition">
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('user.name')">
                <el-input v-model="filterForm.name" :placeholder="$t('user.chooseName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('user.cellphone')">
                <el-input v-model="filterForm.cellphone" :placeholder="$t('user.choosePhone')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('filters.region')">
                <el-select v-model="filterForm.regionNo" :placeholder="$t('filters.chooseRegion')" style="width: 100%"
                  clearable>
                  <el-option v-for="item in regionOptions" :key="item.itemValue" :label="item.itemLabel"
                    :value="item.itemValue">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.reseller')">
                <el-select v-model="filterForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%"
                  clearable>
                  <el-option v-for="item in resellerOptions" :key="item.itemValue" :label="item.itemLabel"
                    :value="item.itemValue">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('user.role')">
                <el-select v-model="filterForm.roleCode" :placeholder="$t('user.chooseRole')" style="width: 100%"
                  clearable>
                  <el-option v-for="item in roleOptions" :key="item.itemValue" :label="item.itemLabel"
                    :value="item.itemValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <el-button type="primary" @click="onAdd(true)" v-if="isAdmin">{{ $t('user.addAdmin') }}</el-button>
                  <!-- <el-button type="primary" @click="onAdd(false)" v-if="isAdmin">{{ $t('user.add') }}</el-button> -->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
              <el-table-column prop="name" :label="$t('user.name')" width="120">
              </el-table-column>
              <el-table-column prop="cellphone" :label="$t('user.cellphone')" width="120">
              </el-table-column>
              <el-table-column prop="regionName" :label="$t('filters.region')">
              </el-table-column>
              <el-table-column prop="resellerName" :label="$t('filters.reseller')">
              </el-table-column>
              <el-table-column prop="roleName" :label="$t('user.role')">
              </el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button @click="editUser(scope.row)" type="text" size="small" v-if="isAdmin">{{ $t('edit')
                  }}</el-button>
                  <el-button @click="deleteUser(scope.row)" type="text" size="small" v-if="isAdmin">{{ $t('delete')
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination background @current-change="currentChange" :current-page="current"
                layout="total, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog :title="$t('user.add')" :visible.sync="CreateDialogVisible" width="40%" center>
      <el-form :model="userForm" ref="userForm" label-width="100px" class="">
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input :placeholder="$t('user.choosePhone')" v-model="userForm.cellphone">
            <template slot="append"><el-button slot="append" icon="el-icon-search"
                @click="queryPhone"></el-button></template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('user.role')" prop="roleName" v-if="userForm.roleName">
          {{ userForm.roleName }}
        </el-form-item>
        <el-form-item :label="$t('filters.reseller')" prop="resellers"
          v-if="!userForm.isAdmin && userForm.roleCode !== 'CARE CLUSTER'">
          <el-select multiple v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">
            <el-option v-for="item in resellerOptions" :key="item.itemValue" :label="item.itemLabel" :value="item.itemValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" prop="regions"
          v-if="!userForm.isAdmin && userForm.roleCode === 'CARE CLUSTER'">
          <el-select multiple v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" style="width: 100%" clearable>
            <el-option v-for="item in regionOptions" :key="item.itemValue" :label="item.itemLabel"
              :value="item.itemValue">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="CreateDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('user.edit')" :visible.sync="EditDialogVisible" width="40%" center>
      <el-form :model="userForm" ref="userForm" label-width="100px" class="">
        <el-form-item :label="$t('user.role')" prop="roleName" v-if="userForm.roleName">
          {{ userForm.roleName }}
        </el-form-item>
        <el-form-item :label="$t('filters.reseller')" prop="resellers" v-if="userForm.roleCode === 'HEADQUARTER'">
          <el-select multiple v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">
            <el-option v-for="item in resellerOptions" :key="item.itemValue" :label="item.itemLabel"
              :value="item.itemValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  :label="$t('filters.region')" prop="regions"
          v-if="userForm.roleCode === 'NikeInternal' || userForm.roleCode === 'HM' || userForm.roleCode === 'MM'">
          <el-select multiple v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" style="width: 100%" clearable>
            <el-option v-for="item in regionOptions" :key="item.itemValue" :label="item.itemLabel"
              :value="item.itemValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="EditDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import _ from 'lodash'
export default {
  name: 'NewSurvey',
  components: {
    topBar: TopBar
  },
  data: function () {
    return {
      filterForm: {
      },
      initFilterForm: {
        cellphone: '', // 状态
        name: '', // 问卷名称
        regionNo: '', // 区域
        resellerNo: '',
        roleCode: '',
      },
      userForm: {
        roleCode: '',
        roleName: '',
        cellphone: '',
        regionNo:[],
        resellerNo:[],
        isAdmin: false
      },
      regionOptions: [],
      resellerOptions: [],
      roleOptions:[
        {
          itemValue:'Admin',
          itemLabel:'开放问卷管理员'
        },
        {
          itemValue:'MM',
          itemLabel:'市场管理'
        },
        {
          itemValue:'NikeInternal',
          itemLabel:'公司总部'
        },
        {
          itemValue:'HEADQUARTER',
          itemLabel:'客户总部'
        }
      ],
      tableData: [], // 表格数据
      total: 0,
      current: 1, // 当前页码
      tableLoading: false,
      EditDialogVisible: false,
      CreateDialogVisible: false,
    }
  },
  mounted() {
    this.loadOption()
    this.onReset()
    this.onSearch()
  },
  computed: {
    isAdmin: ({ $store: { getters } }) => {
      if (getters.isAdmin + '' === 'true') {
        return true
      } else {
        return false
      }
    } // 角色是否是admin
  },
  methods: {
    loadOption: async function () {
      let { data } = await window.instance.post(window.surveyUrl + 'condition/doorFilters', {})
      if (data.code === 200) {
        this.regionOptions = data.data.regions
        this.resellerOptions = data.data.resellers
      }
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.current = 1
      }
      this.tableLoading = true
      const submitData = {
        name: this.filterForm.name,
        cellphone: this.filterForm.cellphone,
        regionNo: this.filterForm.regionNo,
        resellerNo: this.filterForm.resellerNo,
        roleCode: this.filterForm.roleCode,
        size: 10,
        current: this.current
      }
      let res = await window.instance.post(window.surveyUrl + 'account/query', submitData)
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.current = index
      this.onSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    onAdd: function (isAdmin) {
      this.userForm.isAdmin = isAdmin;
      this.userForm.roleCode = '';
      this.userForm.roleName = '';
      this.userForm.cellphone = '';
      this.userForm.regionNo = [];
      this.userForm.resellerNo = [];

      this.CreateDialogVisible = true;
    },
    queryPhone: async function () {
      let { data } = await window.instance.get(window.surveyUrl + 'account?cellphone=' + this.userForm.cellphone)
      if(data.code===200){
      if (!this.userForm.isAdmin) {
        this.userForm.isAdmin = data.data.roleCode === 'Admin';
      }
      this.userForm.roleCode =  data.data.roleCode;
      this.userForm.roleName = data.data.roleName;
      this.userForm.regionNo = data.data.regionNos;
      this.userForm.resellerNo = data.data.resellerNos;
    }
    },
    editUser: function (row) {
      this.formReset();
      this.userForm.cellphone = row.cellphone;
      this.userForm.isAdmin = row.roleCode === 'Admin';
      this.userForm.roleCode =  row.roleCode;
      this.userForm.roleName = row.roleName;
      this.userForm.regionNo = row.regionNos;
      this.userForm.resellerNo = row.resellerNos;
      this.EditDialogVisible = true;
      console.log(this.userForm);
    },
    submitUser: async function () {
      let {regionNo,resellerNo,cellphone,isAdmin} = this.userForm;
      let submitData = {
        regions: regionNo?regionNo:[],
        resellers: resellerNo?resellerNo:[],
        cellphone:cellphone,
        isAdmin:isAdmin
      }

      let url = window.surveyUrl + (isAdmin?'account/addAdmin':'account/add');
      if(this.EditDialogVisible){
        url = window.surveyUrl + 'account/edit';
      }

      let { data } = await window.instance.post(url,submitData)
      if(data.code===200){
        this.formReset();
        this.onSearch()
        this.EditDialogVisible = false;
        this.CreateDialogVisible = false;
      }
    },
    formReset(){
      this.userForm = {
        roleCode: '',
        roleName: '',
        cellphone: '',
        regionNo:[],
        resellerNo:[],
        isAdmin: false
      }
    },
    deleteUser: function (row) {
      const tipContent = this.$t('user.deleteUser') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(window.surveyUrl + 'account/del', { account: row.account })
          res = res.data
          if (res.code === 200) {
            await this.onSearch(false)
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => { })
    },
  }
}
</script>

<style scoped lang="sass">
  #newSurvey
  </style>



// WEBPACK FOOTER //
// src/openSurvey/pages/UserManage.vue